import { AppBar, Box, styled, Toolbar } from '@mui/material';
var StyledAppBar = styled(AppBar)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    position: 'initial'
  };
  return styles;
});
var StyledToolbar = styled(Toolbar)(function (_ref2) {
  var theme = _ref2.theme;
  var styles = {
    height: theme.typography.pxToRem(56),
    minHeight: theme.typography.pxToRem(56),
    width: theme.typography.pxToRem(1632),
    backgroundColor: theme.palette.mirage.main,
    borderBottom: "".concat(theme.typography.pxToRem(1), " solid ").concat(theme.palette.mirage.main)
  };
  return styles;
});
var HeaderItems = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  var styles = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3)
  };
  return styles;
});
export { HeaderItems, StyledAppBar, StyledToolbar };